'use client'

import PropTypes from 'prop-types'
import MUIChip from '@mui/material/Chip'

export const Pill = ({ label, icon = null, color = 'black', backgroundColor = 'error.main', sx }) => {
  return (
    <MUIChip
      data-testid="Pill"
      icon={icon ?? null}
      sx={{
        height: '22px',
        fontSize: '0.75rem',
        backgroundColor,
        color,
        fontWeight: 600,
        '& .MuiChip-label': {
          paddingLeft: icon ? '6px' : '12px'
        },
        ...sx
      }}
      label={label ?? ''}
    />
  )
}

Pill.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  sx: PropTypes.object,
  icon: PropTypes.node
}
